<div class="fixed-width">
    <div class="go-to-all">
        <a class="button-all-tournaments" [routerLink]="['/', missionsTrx]" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <img src="assets/playbison/arrow_left.svg" alt="arrow">
            <span i18n>All Missions</span>
        </a>
    </div>
    <div class="tournamet-banner-flex">
        <div class="tournament-banner-width">
            <div class="tournament-banner">
                <!-- <div class="banner-img">
                    <img src="assets/desktop/tournament/launch-banner.svg">
                </div>
                <div class="banner-content">
                    <div class="duration" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px">
                        <span i18n>5th May 2022, 11:59 PM</span>
                        <span fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                            <img src="assets/desktop/tournament/hour-glass.svg">
                            <span i18n>1d 5h:23m</span>
                        </span>
                    </div>
                    <div class="title" i18n>
                        Lucky 7 Tournament
                    </div>
                </div> -->
                <app-home-page-mission-card *ngIf="mission" [isEmbedded]="true" [mission]="mission" [tournamentIndex]="0"></app-home-page-mission-card>
                <!-- <div *ngIf="tournament?.tournamentMaximumRebuys && isLogin && tournament?.displayBonusName" fxLayoutAlign="space-between center" fxLayout="row" class="rebuy-info">
                        <div fxLayoutAlign="space-between center" fxLayout="row" class="rebuy-info">
                        <div>
                            <div>
                                <span *ngIf="!tournamentRebuyAddPoints" i18n>Rebuy tournament bonus</span>
                                <span *ngIf="tournamentRebuyAddPoints" i18n>Rebuy tournament bonus and get {{tournamentRebuyAddPoints}} points</span>
                            </div>
                            <div><span i18n>available to rebuy</span>: &nbsp;{{availableRebuys}}&nbsp;/&nbsp;<span i18n>acquired</span>:&nbsp;{{rebuysUsed}}</div>
                        </div>
                        <ng-container *ngIf="balance$ | async as balance">
                            <div class="rebuy-button" *ngIf="availableRebuys>0" fxLayoutAlign="center center" fxLayoutGap="5px" fxLayout="row">
                                <div class="rebuy-price">{{rebuyPrice}}{{currency}}</div>
                                <button *ngIf="balance.balance>=rebuyPrice else notenoughfunds" round-button filled="filled" color="accent" (click)="checkConfirmRebuy()" [disabled]="!isSumbitRebuyAllowed" class="mat-primary-font cap" i18n>buy</button>
                            </div>
                        </ng-container>
                    </div> -->
            </div>
            <div class="game-card-wrap" *ngIf="isLogin">
                <h2 i18n>Mission Games:</h2>
                <!-- <swiper style="width: 100%;" [config]="config"> -->
                <div class="tournament-games">
                    <div *ngFor="let game of mission?.games | slice:0:this.rankSize;">
                        <app-missions-games (onGameSelect)="onGameSelect($event)" [game]="game"></app-missions-games>
                    </div>
                </div>
                <div *ngIf="!isShowMore && mission?.games.length > INITIAL_RANK_LENGTH" (click)="this.rankSize=SHOWMORE_RANK_LENGTH; isShowMore=true;" class="load-more">
                    <a>
                        <span i18n>Show More</span>
                        <img src="assets/desktop/tournament/showmore.svg"/>
                        <!-- <mat-icon>arrow_forward_ios</mat-icon> -->
                    </a>
                </div>
                <!-- </swiper> -->
            </div>
        </div>
        <!-- <div class="separtor"></div> -->
        <div class="tournaments-tabs">
            <app-mission-tabs *ngIf="mission" [mission]="mission"></app-mission-tabs>
            <!-- <app-how-mission-works [mission]="mission"></app-how-mission-works> -->
        </div>
    </div>

</div>
<ng-template #notenoughfunds>
    <div class="not-enough-funds-text">
        <span i18n>No funds</span>
    </div>
</ng-template>